<template>
  <div class="app-container">
    <!--  sort="orderSeq" -->
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="serial" :selection="selection" is-list @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />
              <span v-else-if="col.prop === 'constant'">{{ $t(GOODS_PRICE_ITEMS.bjGet(scope.row.value)) }}
              </span>
              <el-tag v-else-if="col.prop === 'enabledFlag'" :type="scope.row[col.prop] ? 'success' : 'info'">{{ $t(STATUS_ENABLED_NUM.bjGet(scope.row[col.prop])) }}</el-tag>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="scope">
              <el-button v-permission:BusinessGoodsPriceItemIndex_Edit type="text" class="edit-btn" @click="onEdit(scope.row)">{{ $t('editText') }}</el-button>
              <el-button v-if="!scope.row.enabledFlag" v-permission:BusinessGoodsPriceItemIndex_Status type="text" @click="onStatus(1, scope.row)">{{ $t('enableText') }}</el-button>
              <el-button v-if="scope.row.enabledFlag" v-permission:BusinessGoodsPriceItemIndex_Status :disabled="scope.row.value == 'costPrice' || scope.row.value == 'salesPrice'" type="text" @click="onStatus(0, scope.row)">{{ $t('disableText') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :title="title" :visible.sync="dialogVisible" :before-close="handleClose" width="500px" append-to-body>
      <el-form ref="form" class="bj-label-colon" label-position="top" :model="form" :rules="rules" label-width="120px">
        <el-col :span="22">
          <BjFormItemCode v-model="form.value" :readonly="!isAdd" :label="$t('goodsPrice.table.code')" prop="value" />
        </el-col>
        <el-col :span="22">
          <el-form-item :label="$t('goodsPrice.table.item')" prop="constant">
            <BjInput v-if="isAdd" v-model="form.constant" :maxlength="MAX_LENGTH.SHORT_NAME" :placeholder="$t('inputText')" clearable />
            <span v-if="!isAdd">{{ $t(GOODS_PRICE_ITEMS.bjGet(form.value)) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="22">
          <el-form-item :label="$t('goodsPrice.table.name')" prop="meaning">
            <BjInput v-model="form.meaning" :maxlength="MAX_LENGTH.SHORT_NAME" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="22">
          <el-form-item :label="$t('table.remarkText')" prop="description">
            <BjInput v-model="form.description" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="handleConfirm('form')">{{ $t('okText') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// TODO:  系统维护好价格项，不能添加修改，只能隐藏/开启，默认成本价、销售价开启
import pageMiXin from '@/utils/page-mixin.js';
import { goodsApi } from '@/api';
import { GOODS_PRICE_ITEMS, STATUS_ENABLED_NUM } from '@/utils/constants';
const getDefaultForm = () => {
  return {
    orderSeq: 0,
    value: null,
    meaning: null,
    description: null,
    enabledFlag: 1,
  };
};

export default {
  name: 'BusinessGoodsPriceItem',
  mixins: [pageMiXin],
  data() {
    return {
      GOODS_PRICE_ITEMS,
      STATUS_ENABLED_NUM,
      selection: false,
      queryApi: goodsApi.getListPriceItem,
      // 查询参数
      queryParams: {},
      title: '',
      dialogVisible: false,
      // 表单参数
      isAdd: false,
      form: getDefaultForm(),
      // 表单校验
      rules: {
        value: [{ required: true, message: this.$t('goodsPrice.page.PleaseCode'), trigger: 'blur' }],
        meaning: [{ required: true, message: this.$t('goodsPrice.page.PleaseName'), trigger: 'blur' }],
      },
      labelList: [
        { label: 'goodsPrice.table.code', prop: 'value', isCheck: true, disabled: false },
        { label: 'goodsPrice.table.item', prop: 'constant', isCheck: true, disabled: false },
        { label: 'goodsPrice.table.name', prop: 'meaning', isCheck: true, disabled: false },
        { label: 'table.remarkText', prop: 'description', isCheck: true, disabled: false },
        { label: 'table.statusText', prop: 'enabledFlag', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 129 },
      ],
    };
  },
  computed: {},
  watch: {
    'form.orderSeq'(v) {
      this.form.orderSeq = Number(String(v).replace(/[^0-9]/g, ''));
    },
    'form.value'(v) {
      this.form.value = this.form.value.replace(/\s+/g, '');
    },
  },
  mounted() {},
  methods: {
    onStatus(flag, row) {
      const TEXT = this.$t(STATUS_ENABLED_NUM.bjGet(flag));
      this.$confirm(
        `${this.$t('toast.youAreTipText')} ${TEXT} ${row.meaning}，${this.$t(
          'toast.continueTipText',
        )}`,
        this.$t('toast.hintText'),
        {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        },
      )
        .then(() => {
          this.updateApi({
            ...row,
            enabledFlag: flag,
          });
        })
        .catch(() => {});
    },
    handleConfirm(formName) {
      if (
        this.$refs.BjPage.tableData.find(
          row => row.meaning == this.form.meaning && row.value != this.form.value,
        )
      ) {
        this.$message.warning(this.$t('goodsPrice.page.DuplicateName'));
        return;
      }

      const API_DATA = this.$lodash.clone(this.form);
      this.$refs[formName].validate(valid => {
        if (!valid) return this.$scrollToFormError();
        if (this.isAdd) {
          this.addApi(API_DATA);
        } else {
          this.updateApi(API_DATA);
        }
      });
    },
    /** 删除操作 */
    onDelete(row) {
      this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.batchDeleteApi({ value: row.value });
        })
        .catch(() => {});
    },
    /** 新建 */
    onAdd() {
      this.isAdd = true;
      this.title = this.$t('goodsPrice.page.AddPrice');
      this.form = getDefaultForm();
      this.dialogVisible = true;
    },
    /** 编辑操作 */
    onEdit(row) {
      this.isAdd = false;
      this.title = this.$t('goodsPrice.page.EditPrice');
      this.dialogVisible = true;
      this.selectedRow = this.$lodash.clone(row);
      this.form = this.$lodash.clone(row);
    },
    /* 关闭弹窗 */
    handleClose() {
      this.dialogVisible = false;
    },
    // 修改API
    updateApi(API_DATA) {
      goodsApi.updatePriceItem(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.dialogVisible = false;
            this.reFresh();
            // 刷新价格项值集的缓存
            this.$store.dispatch('values/getValueList', {
              POST_KEY: 'PRICE.ITEM.TYPE',
              isCache: false,
            });
          }, 500);
        }
      });
    },
    // 新增API
    addApi(API_DATA) {
      goodsApi.addPriceItem(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.dialogVisible = false;
            this.reFresh();
          }, 500);
        }
      });
    },
    batchDeleteApi(API_DATA) {
      goodsApi.deletePriceItem(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
            // 刷新价格项值集的缓存
            this.$store.dispatch('values/getValueList', {
              POST_KEY: 'PRICE.ITEM.TYPE',
              isCache: false,
            });
          }, 500);
        }
      });
    },
  },
};
</script>
